import React from "react";
import PropTypes from "prop-types";
import { IconButton } from "@mui/material";
import { Download } from "lucide-react";

import { UIModal } from "../../../ui";
import ClientReportFileRow from "./ClientReportFileRow";
import { formatClientReportSize } from "./clientReportMappers";

import "./ClientReports.scss";

const DownloadClientReportModal = ({
  open,
  labels,
  report,
  downloading,
  onClose,
  onDownload,
}) => (
  <UIModal
    open={open}
    type="info"
    title={labels.title}
    cancelLabel={labels.cancel}
    onClose={onClose}
    onCancel={onClose}
    cancelButtonProps={{ disabled: downloading }}
    PaperProps={{ className: "client-report-modal" }}
    maxWidth="sm"
    fullWidth
  >
    {report ? (
      <div className="client-report-modal__body">
        <ClientReportFileRow
          title={report.name}
          subtitle={[
            labels.readyToDownload,
            formatClientReportSize(report.size),
          ]
            .filter(Boolean)
            .join(" • ")}
          fileType={report.fileType}
          action={
            <IconButton
              type="button"
              className="client-report-file-row__action"
              aria-label={labels.download}
              disabled={downloading}
              onClick={() => onDownload(report)}
            >
              <Download size={18} strokeWidth={1.75} />
            </IconButton>
          }
        />
      </div>
    ) : null}
  </UIModal>
);

DownloadClientReportModal.propTypes = {
  open: PropTypes.bool.isRequired,
  labels: PropTypes.shape({
    title: PropTypes.node.isRequired,
    cancel: PropTypes.node.isRequired,
    download: PropTypes.string,
    readyToDownload: PropTypes.string,
  }).isRequired,
  report: PropTypes.object,
  downloading: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onDownload: PropTypes.func.isRequired,
};

DownloadClientReportModal.defaultProps = {
  report: null,
  downloading: false,
};

export default DownloadClientReportModal;
